module.exports = __webpack_public_path__ + "img/046-stare.a065f21b.svg";